import { render, staticRenderFns } from "./ChannelCategorySelect.vue?vue&type=template&id=3aa49ae8&scoped=true&"
import script from "./ChannelCategorySelect.vue?vue&type=script&lang=js&"
export * from "./ChannelCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCategorySelect.vue?vue&type=style&index=0&id=3aa49ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa49ae8",
  null
  
)

export default component.exports